import React, { useContext } from "react";
import styles from "./HomeFooter.module.scss";
import { Context } from "../../Store";
import logo from "../../../imgs/myCashLogo1.png";
import googlePlayImage from "../../../imgs/googlePlay.png";
import appStoreImage from "../../../imgs/appStore.png";
import upArraw from "../../../imgs/upArraw.png";
import payImg0 from "../../../imgs/payImg0.png";
import payImg1 from "../../../imgs/payImg1.png";
import payImg2 from "../../../imgs/payImg2.png";
import payImg3 from "../../../imgs/payImg3.png";
import payImg4 from "../../../imgs/payImg4.png";

const HomeFooter = () => {
  let { dir, translate, scrollToSection, homeSection, siteInfoRes } =
    useContext(Context);
  let { address, appStore, googlePlay, phone } = siteInfoRes;
  let { moreAboutUs, taxNumber, paymentMethod } = translate.home.homeFooter;

  return (
    <>
      <section id={styles.homeFooter}>
        <div className={styles.container}>
          <div className={styles.item1}>
            <img className={styles.logo} src={logo} alt="" />
            <div className={styles.stores}>
              <a href={googlePlay} target="_blank">
                <img
                  className={
                    dir === "ltr"
                      ? `${styles.imgSL} ${styles.googlePlay}`
                      : `${styles.imgSR} ${styles.googlePlay}`
                  }
                  src={googlePlayImage}
                  alt=""
                />
              </a>
              <a href={appStore} target="_blank">
                <img
                  className={
                    dir === "ltr"
                      ? `${styles.imgSL} ${styles.googlePlay}`
                      : `${styles.imgSR} ${styles.appStore}`
                  }
                  src={appStoreImage}
                  alt=""
                />
              </a>
            </div>
            <img
              className={styles.upArraw}
              onClick={() => scrollToSection(homeSection)}
              src={upArraw}
              alt=""
            />
          </div>
          <div className={styles.item2}>
            <div className={styles.aboutUs}>
              <h3>{dir === "ltr" ? moreAboutUs[0] : moreAboutUs[1]}</h3>
              <p>{address}</p>
              <p>{dir === "ltr" ? taxNumber[0] : taxNumber[1]}</p>
              <p>info@mycash.sa</p>
            </div>
            {/* <div className={styles.payments}>
              <h3>{dir === "ltr" ? paymentMethod[0] : paymentMethod[1]}</h3>
              <div className={styles.paysWAys}>
                <img
                  className={dir === "ltr" ? styles.imgPL : styles.imgPR}
                  src={payImg0}
                  alt=""
                />
                <img
                  className={dir === "ltr" ? styles.imgPL : styles.imgPR}
                  src={payImg1}
                  alt=""
                />
                <img
                  className={dir === "ltr" ? styles.imgPL : styles.imgPR}
                  src={payImg2}
                  alt=""
                />
                <img
                  className={dir === "ltr" ? styles.imgPL : styles.imgPR}
                  src={payImg3}
                  alt=""
                />
                <img
                  className={dir === "ltr" ? styles.imgPL : styles.imgPR}
                  src={payImg4}
                  alt=""
                />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeFooter;
